import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=3606ece5&"
import script from "./Usuarios.vue?vue&type=script&lang=ts&"
export * from "./Usuarios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Usuarios.vue"
export default component.exports